/**
 * DecisionFlow — SeatLimitBanner
 * ui/src/components/SeatLimitBanner.jsx
 * OI-SEAT-IMPLEMENTATION · S660
 *
 * Shown in CompAdminShell between TrialBanner and main content
 * when active_positions > max_positions (seat overflow state).
 *
 * Trigger: tenantContext.active_positions > tenantContext.max_positions
 * tenant_context_router.py already returns both values.
 *
 * Returns null when:
 *   - Either value is missing (loading or not set)
 *   - active_positions <= max_positions (within limit)
 *
 * Design rules (§15):
 *   - No dark: prefix
 *   - rgb(var(--color-*)) throughout
 *   - Matches TrialBanner pattern in CompAdminShell exactly
 */

export function SeatLimitBanner({ activePositions, maxPositions }) {
  if (!activePositions || !maxPositions) return null;
  if (activePositions <= maxPositions) return null;

  const over = activePositions - maxPositions;

  return (
    <div className="flex items-center gap-3 border-b border-[rgb(var(--color-danger))]/30 bg-[rgb(var(--color-danger))]/5 px-4 py-2.5">
      <p className="text-tok-sm font-medium text-[rgb(var(--color-danger))]">
        ⚠ {over} position{over !== 1 ? "s are" : " is"} over your seat limit of{" "}
        {maxPositions}. These positions will not be included in calculations.
        Contact your administrator to purchase additional seats.
      </p>
    </div>
  );
}
